module.exports = __webpack_public_path__ + "img/passo_2.3914b872.png";